import { GET_SUPPLIERS_FAILURE, GET_SUPPLIERS_REQUEST, GET_SUPPLIERS_RESET, GET_SUPPLIERS_SUCCESS } from "redux/actions/action-type"

const initialState = {
    isGetSuppliersLoading: false,
    isGetSuppliersSuccess: false,
    isGetSuppliersFail: false,
    getSuppliersResponse: []
}

export const suppliersReducer = (state = initialState, { type, getSuppliersResponse }) => {
    switch (type) {
        case GET_SUPPLIERS_REQUEST:
            return {
                ...state,
                isGetSuppliersLoading: true,
                isGetSuppliersSuccess: false,
                isGetSuppliersFail: false,
            }
        case GET_SUPPLIERS_SUCCESS:
            return {
                ...state,
                isGetSuppliersLoading: false,
                isGetSuppliersSuccess: true,
                isGetSuppliersFail: false,
                getSuppliersResponse: getSuppliersResponse.data
            }
        case GET_SUPPLIERS_FAILURE:
            return {
                ...state,
                isGetSuppliersLoading: false,
                isGetSuppliersSuccess: false,
                isGetSuppliersFail: true,
                getSuppliersResponse: getSuppliersResponse
            }
        case GET_SUPPLIERS_RESET:
            return {
                ...initialState
            }
        default:
            return {
                ...state
            }
    }
}